import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import PageSection from '../../components/PageSection';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20
  },
  mt30: {
    marginTop: 30
  },
  intro: {
    marginTop: 30,
    marginBottom: 30,
    padding: 30,
    textAlign: 'center',
  },
  introTitle: {
    color: theme.palette.primary.main,
    fontSize: 48,
    fontWeight: 'bold',
    marginBottom: 30
  },
  font: {
    fontSize: 19,
    color: theme.palette.grey.main
  }
}));

const studioClasses = [
  {
    id: 1,
    title: 'Little Mozarts',
    description: 'Young students are introduced to new musical concepts that are reinforced throughout the program through the stories told by composer puppetry (from all 4 music periods) that appeal to the student’s imagination. Classes engage students in the performance of pieces at the piano with an emphasis on ear training, tempo and rhythm, finger dexterity and strength.',
    image: 'https://musicology-studio.s3.amazonaws.com/Little_Mozart.jpg',
  },
  {
    id: 2,
    title: 'Beginners',
    description: 'There is a focus on creating strong foundational skills. Connected activities alternate between music and movement, theory instruction, technical studies, and performance songs for yearly shows, concerts and the Piano Guild.',
    image: 'https://s3.amazonaws.com/musicology.website-images/class-theories/Beginner.jpeg',
  },
  {
    id: 3,
    title: 'Advanced',
    description: 'Structured classes delve further into piano technique and music theory with a focus on major and minor scales, cadences, and arpeggios. Students develop a wide repertoire of songs representing the Baroque, Romantic, Classical and Contemporary periods. Classes support the preparation of solo and duet pieces for the Piano Guild, holiday concerts, piano shows, and piano competitions.',
    image: 'https://musicology-studio.s3.amazonaws.com/Adult.jpg',
  },
  {
    id: 4,
    title: 'Adults',
    description: 'Introductory and intermediate piano lessons provide instruction in complex musical analysis, technical exercises that improve strength and flexibility, and ear training activities. Understanding music theory helps to understand the language of music and explain the music we hear. Studying music helps to reduce stress levels, which can also help minimize other health issues.',
    image: 'https://s3.amazonaws.com/musicology.website-images/class-theories/Adult.jpg',
  }
];

export default function StudioClasses() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.font} variant="subtitle1">
        Classes include music theory, performance skills, technique, ear training, sight-reading,
        composition and more.
      </Typography>

      <div className={classes.mt30}>
        {studioClasses.map(cl => <PageSection key={cl.id} section={cl} plain fullWidth divider circular /> )}
      </div>
    </div>
  )
}

